import './facebook';
// import './google';
import './vuex-router-sync';
import './google-analytics';
import './vue-media-query';
import './vue-hotjar';
import './vue-tag-manager';
import './vue-meta';
